'use client'
import { useIsLoggedInQuery } from 'auth/hooks'
import { useTranslations } from 'next-intl'
import { Link } from '@repo/web-ui/components/link'
import { AppRoutes } from '@repo/web-utils/app-routes'

import { useClubhousesIsMemberQuery } from '@web/gen/clubhouses'
import { JoinClubhouseButton } from './join-clubhouse-button'
export const InviteButton = ({ slug }: { slug: string }) => {
  const t = useTranslations('pages.clubhouse')
  const isLoggedInQuery = useIsLoggedInQuery()
  const { data: isMember } = useClubhousesIsMemberQuery(
    { input: { clubhouseSlug: slug } },
    {
      enabled: isLoggedInQuery.data,
      select: data => data?.clubhousesIsClubhouseMember?.isMember,
    },
  )

  if (isLoggedInQuery && isMember) {
    return (
      <div className="flex gap-2">
        {isMember}
        <Link
          href={`${AppRoutes.CLUBHOUSE}${slug}/members/invite/`}
          className="rounded-2 bg-cf-white text-14 text-legacy-cf-purple-100 border-legacy-cf-purple-100 border-2 p-2 font-medium leading-4 transition-colors duration-500 hover:bg-[#F3EEFE]"
        >
          {t('invite_button')}
        </Link>
        <JoinClubhouseButton slug={slug} />
      </div>
    )
  }

  return null
}
